import { Users } from "lucide-react";
import { fmt } from "./KarolMetricsCards";

const SEGMENT_LABELS = {
  champion:      "Campeões",
  loyal:         "Fiéis",
  recurring:     "Recorrentes",
  at_risk:       "Em risco",
  dormant:       "Dormentes",
  new_customer:  "Novos",
  unknown:       "Sem classificar",
};

export function KarolCustomerIdentitySection({ customerIdentitySnapshot }) {
  if (!customerIdentitySnapshot || customerIdentitySnapshot.error) return null;

  const snap = customerIdentitySnapshot;
  const dist = snap.segment_distribution ?? {};
  const channels = snap.top_channels ?? [];

  return (
    <div className="space-y-3" data-testid="customer-identity-section">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Identidade do cliente
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          <div>
            <p className="text-[10px] text-gray-400 uppercase">Clientes</p>
            <p className="font-semibold text-gray-800">{snap.customer_count ?? 0}</p>
          </div>
          <div>
            <p className="text-[10px] text-gray-400 uppercase">Activos (30d)</p>
            <p className="font-semibold text-gray-800">{snap.active_customers_30d ?? 0}</p>
          </div>
          <div>
            <p className="text-[10px] text-gray-400 uppercase">Dormentes</p>
            <p className="font-semibold text-gray-800">{snap.dormant_customers ?? 0}</p>
          </div>
          <div>
            <p className="text-[10px] text-gray-400 uppercase">Campeões</p>
            <p className="font-semibold text-gray-800">{snap.champions_count ?? 0}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0">
            <Users className="w-4 h-4 text-gray-400" />
          </div>
          <div>
            <p className="text-[10px] text-gray-400 uppercase">LTV médio</p>
            <p className="text-sm font-semibold text-gray-800">{fmt(snap.avg_customer_ltv ?? 0)}</p>
          </div>
        </div>

        {channels.length > 0 && (
          <div>
            <p className="text-[10px] text-gray-400 uppercase mb-2">Canais principais</p>
            <div className="flex flex-wrap gap-2">
              {channels.map((ch, i) => (
                <span
                  key={i}
                  className="text-[11px] px-2 py-1 rounded-full bg-gray-100 text-gray-600"
                >
                  {ch.channel ?? "—"} ({ch.orders ?? 0})
                </span>
              ))}
            </div>
          </div>
        )}

        <div>
          <p className="text-[10px] text-gray-400 uppercase mb-2">Segmentos</p>
          <div className="grid grid-cols-2 gap-2 text-xs">
            {Object.entries(SEGMENT_LABELS).map(([key, label]) => (
              <div key={key} className="flex justify-between text-gray-600">
                <span>{label}</span>
                <span className="font-semibold text-gray-800">{dist[key] ?? 0}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
